import React from 'react';

import { Button } from '../../ui/button';
import type { CustomScreenComponentProps } from './types';
import onboardingContent from './onboardingContent.json';
import { Card, CardContent, CardTitle } from 'components/ui/card';
import { getTestId } from 'utils/testUtils';
import RadarChartImage from 'assets/Images/RadarChartImage.svg';

export const OnboardingComplete: React.FC<CustomScreenComponentProps> = ({
  question,
  isSubmitting,
  onComplete,
}) => {

  return (
    <Card
        {...getTestId(`question-card-${question.id}`)}
        padding="none"
        className="w-full max-w-[35rem]"
    >
        <CardTitle className="pt-5 pb-4 px-10" title={onboardingContent.completion.title}/>
        <CardContent variant="userResponse" padding='large'>
            <img
                src={RadarChartImage}
                alt="Radar chart showing high performance living pillars"
                className="mx-auto max-w-[20rem] w-full"
            />
            {onboardingContent.completion.body}
        </CardContent>
        <div className='p-6'>
            <Button onClick={() => onComplete()} disabled={isSubmitting} type="button" variant="secondary" size='auto'>
                Continue
            </Button>
        </div>
    </Card>
  );
};
